<template>
    <div class="item m-b">
        <div
            :class="color"
            class="b-r-lg p-sm font-bold border value"
        >
            {{declaration.value}}
        </div>
        <div class="font-bold m-l">
            {{declaration.label}}
        </div>
    </div>
</template>

<script>
export default {
    name:'Indicador',
    props:{
        declaration:Object,
        color:String,
    }
}
</script>

<style lang="scss">
    .item{
        display: flex;
        align-items: center;
        .value{
            max-width: 30%;
            min-width: 4em;
            text-align: center;
        }
    }
</style>
